import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"

export type RetrieveRecentTransactionCountsResponse = {
  countOverLast1Minute: number
  countOverLast5Minutes: number
  countOverLast15Minutes: number
  countOverLast1MinuteThisTimeLastWeek: number
  countOverLast5MinutesThisTimeLastWeek: number
  countOverLast15MinutesThisTimeLastWeek: number
  countsOverLast30MinutesBy5MinuteWindow: number[]
  countsOverLast30MinutesBy5MinuteWindowThisTimeLastWeek: number[]
}

const RECENT_TRANSACTION_COUNTS_QUERY_KEY =
  "recent_transaction_counts"

export const retrieveRecentTransactionCountsData =
  async (): Promise<RetrieveRecentTransactionCountsResponse> => {
    const { body } =
      await api.get<RetrieveRecentTransactionCountsResponse>(
        "/recent_transaction_counts/"
      )

    return body
  }

export const useRecentTransactionCounts = () =>
  useQuery({
    queryKey: [RECENT_TRANSACTION_COUNTS_QUERY_KEY],
    queryFn: () => retrieveRecentTransactionCountsData(),
    retry: 2,
    refetchInterval: 60 * 1000,
  })
